import React, { lazy } from 'react'
import { TaxSchemeListing } from './TaxSchemeListing'
import { TaxSchemeForm } from './TaxSchemeForm'
import { TaxSchemeDetails } from './TaxSchemeDetails'

const TaxSchemeRoutes = [
  {
    props: {
      exact: true,
      path: '/common-setting/tax-scheme',
    },
    component: <TaxSchemeListing />,
  },
  {
    props: {
      exact: true,
      path: '/common-setting/tax-scheme/add',
    },
    component: <TaxSchemeForm mode="add" />,
  },
  {
    props: {
      exact: true,
      path: '/common-setting/tax-scheme/:TaxSchemeID/edit',
    },
    component: <TaxSchemeForm mode="edit" />,
  },
  {
    props: {
      exact: true,
      path: '/common-setting/tax-scheme/:TaxSchemeID/view',
    },
    component: <TaxSchemeDetails mode="view" />,
  },
]
export default TaxSchemeRoutes
